import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-card flex items-center justify-center pt-[10px]">
            <div className="text-center">
                <h1 className="text-8xl font-bold text-[#FF6B35] mb-4">404</h1>
                <h2 className="text-3xl font-bold text-foreground mb-4">Page Not Found</h2>
                <p className="text-muted-foreground mb-8">The page you are looking for doesn't exist.</p>
                <button onClick={() => navigate('/')} className="px-8 py-3 bg-[#FF6B35] text-white rounded-lg font-semibold hover:bg-[#E55A2B] transition-colors whitespace-nowrap">Go Home</button>
            </div>
        </div>
    );
}
